import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const getDismissedIncidents = (state: RootState) => state.domains.incidents.dismissed;

export const getUnresolvedIncidents = createSelector(
  getDismissedIncidents,
  (state: RootState) => state.domains.incidents.unresolved,
  (dismissed, unresolved) => unresolved.filter((item) => !dismissed.includes(item.id)),
);
